import { Route, Switch, Redirect } from 'react-router'
import React from  'react'
import SerachPage from './pages/search'

const routes = (
    <Switch>
        <Redirect exact path="/" to="/search" />
        <Route exact path="/search" component={SerachPage} />
        <Route path="/test" render={() => <h1>test!</h1>} />
        <Route render={() => <h1>Not Found!</h1>} />
    </Switch>
);

export default routes;
